import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const dairyPlan: ImportTypeConfig = {
  dateFormat: { default: 'DD/MM/YYYY' },
  importType: true,
  instructions: {
    fileInstructionKey: 'select_exported_file_dairyplan',
    software: 'DairyPlan',
    spreadsheetName: { lowerFirst: true, messageKey: 'configured_by_cowmed_team' },
  },
  type: 'dairy-plan',
}
